import { render, staticRenderFns } from "./AppPageLayout.vue?vue&type=template&id=08238b34"
import script from "./AppPageLayout.vue?vue&type=script&lang=js"
export * from "./AppPageLayout.vue?vue&type=script&lang=js"
import style0 from "./AppPageLayout.vue?vue&type=style&index=0&id=08238b34&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports